import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { ApplicationService } from "../../services/application.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-global-loading",
  templateUrl: "./global-loading.component.html",
  styleUrls: ["./global-loading.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner, AsyncPipe],
})
export class GlobalLoadingComponent {
  applicationService = inject(ApplicationService);
}
